import { useState } from 'react';
import classNames from '@/lib/misc/classNames';
const PercentageButton = ({
  value,
  setPercentage
}) => {
  const [isPressed, setIsPressed] = useState(false);
  return <div className={classNames('bg-genius-blue rounded-full ta-c text-[14px] text-genius-cream font-medium flex items-center px-4 py-1 transition-transform', isPressed ? 'scale-[0.85]' : 'scale-[1]')} onTouchStart={() => setIsPressed(true)} onTouchEnd={() => {
    setIsPressed(false);
    setPercentage(value);
  }} onTouchCancel={() => setIsPressed(false)} data-sentry-component="PercentageButton" data-sentry-source-file="SelectPercentage.tsx">
      <p className='m-auto'>{value === 100 ? 'ALL' : `${value}%`}</p>
    </div>;
};
export default function SelectPercentage({
  setPercentage
}: {
  setPercentage: (num: number) => void;
}) {
  return <div className='flex items-center justify-center gap-3' data-sentry-component="SelectPercentage" data-sentry-source-file="SelectPercentage.tsx">
      <PercentageButton value={10} setPercentage={setPercentage} data-sentry-element="PercentageButton" data-sentry-source-file="SelectPercentage.tsx" />
      <PercentageButton value={25} setPercentage={setPercentage} data-sentry-element="PercentageButton" data-sentry-source-file="SelectPercentage.tsx" />
      <PercentageButton value={50} setPercentage={setPercentage} data-sentry-element="PercentageButton" data-sentry-source-file="SelectPercentage.tsx" />
      <PercentageButton value={100} setPercentage={setPercentage} data-sentry-element="PercentageButton" data-sentry-source-file="SelectPercentage.tsx" />
    </div>;
}